// import { AbstractConnector } from "@web3-react/abstract-connector"
import { WALLET_CONNECTOR } from "src/constants"
import { NETWORK_CONFIG } from "src/constants/networks"
import { getChainId } from "."

export function hasSwitchFunction(connector: WALLET_CONNECTOR) {
  return (
    (connector === WALLET_CONNECTOR.METAMASK ||
      connector === WALLET_CONNECTOR.BRAVEWALLET) &&
    window.ethereum !== undefined
  )
}

const setupNetwork = async () => {
  const provider = window.ethereum
  const chainId = getChainId()
  if (provider) {
    try {
      await provider.request({
        method: "wallet_addEthereumChain",
        params: [NETWORK_CONFIG[chainId]],
      })
      return true
    } catch (error) {
      console.error("Failed to setup the network in Metamask:", error)
      return false
    }
  } else {
    console.error(
      "Can't setup the Cronos network on metamask because window.ethereum is undefined",
    )
    return false
  }
}

/**
 * Switch to Cronos if the wallet is on a different network, or prompt the user to add Cronos as a network on Metamask
 * @returns {boolean} true if the setup succeeded, false otherwise
 */
export const switchNetwork = async () => {
  const provider = window.ethereum
  const chainId = getChainId()

  if (provider) {
    try {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: NETWORK_CONFIG[chainId].chainId }],
      })
      return true
    } catch (error) {
      console.error("Failed to switch network in Metamask:", error)
      return await setupNetwork()
    }
  } else {
    console.error(
      "Can't switch to Cronos network on metamask because window.ethereum is undefined",
    )
    return false
  }
}
